import { useParams } from "react-router-dom";
import { usePartnerWorkingFolderStore } from "../../../../stores/Cac/Partner/partnerWorkingFolder";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import { useState } from "react";
import { createNewUserWorkingFolder } from "../../../../services/Api/customerService";

const AddUserWorkingFolder = () => {
  const {
    updateWorkingFolder,
    setUpdateWorkingFolder,
    addUserModal,
    setAddUserModal,
  } = usePartnerWorkingFolderStore();
  const { idCustomer, idWorkingFolder } = useParams();
  const [email, setEmail] = useState("");

  const handleAddUser = () => {
    const data = {
      email: email,
    };
    createNewUserWorkingFolder(
      Number(idCustomer),
      Number(idWorkingFolder),
      data
    )
      .then(() => {
        setUpdateWorkingFolder(!updateWorkingFolder);
        setAddUserModal(false);
        setEmail("");
        showToastSuccess("Accès envoyé avec succès");
      })
      .catch(() => {
        showToastError("Erreur lors de l'envoi de l'accès");
      });
  };

  return (
    addUserModal && (
      <>
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
          <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[65%]">
            {/* Content */}
            <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
              {/* Header */}
              <div className="w-full bg-white p-3 rounded-t-xl">
                <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                  </svg>
                  Ajouter un utilisateur
                </h4>
              </div>
              
              {/* Body */}
              <div className="w-full flex flex-col items-center justify-center text-grey-trio">
                <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                    Ajouter un nouvel utilisateur
                  </h3>
                  <p className="text-md text-gray-600 text-center mb-4">
                    Vous vous apprêtez à ajouter un utilisateur et à lui envoyer
                    un lien d'accès au dossier de travail.
                  </p>
                  
                  {/* Input email */}
                  <div className="w-full max-w-md">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2 text-left">
                      Adresse email
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="exemple@email.com"
                      className="w-full h-11 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                    />
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
                <button
                  className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-gray-200 cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                  type="button"
                  onClick={() => setAddUserModal(false)}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
                  type="button"
                  onClick={() => {
                    handleAddUser();
                  }}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default AddUserWorkingFolder;
